const clubbing = [

    {label:"Side",
    controlType:"radio button",
    options:["Bilateral","Right", "Left", ]
    }

]



export default clubbing